import { useEffect, useState } from "react";

const navLinks = [
  { label: "本期封面", href: "#covers" },
  { label: "街拍更新", href: "#street" },
  { label: "话题墙", href: "#topics" },
  { label: "同款穿搭", href: "#compare" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/85 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex h-16 items-center justify-between">
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
            <span className="grid h-8 w-8 place-items-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
              <i className="ri-camera-line text-lg" />
            </span>
            <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
              吃瓜图集
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-600 transition-colors hover:text-primary-600 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-2 md:flex">
            <button
              type="button"
              aria-label="搜索"
              className="grid h-9 w-9 cursor-pointer place-items-center rounded-md text-foreground-700 transition-colors hover:bg-background-100"
            >
              <i className="ri-search-line text-lg" />
            </button>
            <a
              href="#compare"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              去生图对比
            </a>
          </div>

          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="grid h-9 w-9 cursor-pointer place-items-center rounded-md text-foreground-700 hover:bg-background-100 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 backdrop-blur-md px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#compare"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50 dark:text-foreground-950"
            >
              去生图对比
            </a>
          </div>
        </div>
      )}
    </header>
  );
}